import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { AppLayout, ProtectedRoute } from './components/layout/Layout';

import LoginPage       from './pages/auth/LoginPage';
import RegisterPage    from './pages/auth/RegisterPage';
import BikesPage       from './pages/bikes/BikesPage';
import BikeDetailPage  from './pages/bikes/BikeDetailPage';
import CartPage        from './pages/cart/CartPage';
import BookingsPage    from './pages/bookings/BookingsPage';
import PlaceOrderPage  from './pages/order/PlaceOrderPage';
import AdminDashboard  from './pages/admin/AdminDashboard';

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <CartProvider>
        <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
        <Routes>
          <Route element={<AppLayout />}>
            {/* Public */}
            <Route path="/"        element={<Navigate to="/bikes" replace />} />
            <Route path="/login"    element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/bikes"    element={<BikesPage />} />
            <Route path="/bikes/:id" element={<BikeDetailPage />} />

            {/* Protected: any logged-in user */}
            <Route element={<ProtectedRoute />}>
              <Route path="/cart"        element={<CartPage />} />
              <Route path="/place-order" element={<PlaceOrderPage />} />
              <Route path="/bookings"    element={<BookingsPage />} />
            </Route>

            {/* Protected: admin only */}
            <Route element={<ProtectedRoute adminOnly />}>
              <Route path="/admin" element={<AdminDashboard />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/bikes" replace />} />
          </Route>
        </Routes>
      </CartProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
